export default __webpack_public_path__ + "static/media/sprite.90e8ad9ed49afa1c1bcfa41e738efac7.svg";